import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useUserAuth } from '@/context/UserAuthContext';

export function UserProtectedRoute() {
  const { isAuthenticated } = useUserAuth();
  if (!isAuthenticated) return <Navigate to={ROUTES.login} replace />;
  return <Outlet />;
}

export function UserPublicRoute() {
  const { isAuthenticated } = useUserAuth();
  if (isAuthenticated) return <Navigate to={ROUTES.dashboard} replace />;
  return <Outlet />;
}
